import { render } from "./ExportsList.vue?vue&type=template&id=4c922ca9&scoped=true"
import script from "./ExportsList.vue?vue&type=script&lang=ts"
export * from "./ExportsList.vue?vue&type=script&lang=ts"

import "./ExportsList.vue?vue&type=style&index=0&id=4c922ca9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4c922ca9"

export default script